export const ITEMS_PER_PAGE = 20;

export const DRAG_DISTANCE_THRESHOLD_PX = 28;
export const DRAG_VELOCITY_THRESHOLD = 0.35;

export const INFINITE_SCROLL_ROOT_MARGIN = '200px';

export const DEFAULT_PRELOAD_RANGE = 2;
export const OPEN_SLIDESHOW_PRELOAD_RANGE = 5;
export const SLIDE_WINDOW_RADIUS = 10;

export const DEEPLINK_PARAM_FOTO_ID = 'fotoId';

export const SETTINGS_KEYS = {
  enableSingleImageDownload: 'enable_single_image_download',
  enableSingleImageDescription: 'enable_single_image_description',
  enableComments: 'enable_comments',
  enableLikes: 'enable_likes',
} as const;
